// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { Step09MedicalWishes } from './Step09MedicalWishes'
import type { SaveStatus } from '@/hooks/useAutosave'

export function NewStep12Medical(props: { onSaveStatus: (s: SaveStatus) => void }) {
  return <Step09MedicalWishes {...props} />
}
